import React from 'react';
import './sidebar.css';
import picture from '../images/picture.jpg';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faAngellist } from '@fortawesome/fontawesome-free-brands';
import { faEnvelope } from '@fortawesome/fontawesome-free-solid';

const decode = (str) => {
  let newString = "";
  for (let i = 0; i < str.length; i++) {
    const newNumber = (str.charCodeAt(i) + 2);
    let newLetter;
    if (newNumber > 122) {
      newLetter = String.fromCharCode(96 + (newNumber % 122));
    } else {
      newLetter = String.fromCharCode(newNumber);
    }
    newString += newLetter;
  }
  return newString;
};

const Sidebar = () => {
  return (
    <div className="sidebar-main">
      <div className="sidebar-photo">
        <img src={picture}></img>
      </div>
      <div className="sidebar-links">
        <span><a href="https://github.com/aschneit" target="_new">
          <FontAwesomeIcon className="github-icon" icon={faGithub} />
        </a></span>
      <span><a href="https://www.linkedin.com/in/aschneit/" target="_new">
          <FontAwesomeIcon className="linkedin-icon" icon={faLinkedin} />
        </a></span>
      <span><a href="https://angel.co/adam-schneit" target="_new">
          <FontAwesomeIcon className="angellist-icon" icon={faAngellist} />
        </a></span>
      <span><a href={`mailto:${decode("yqaflcgr")}@gmail.com`} target="_new">
          <FontAwesomeIcon className="email-icon" icon={faEnvelope} />
        </a></span>
      </div>
    </div>
  );
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/nav/sidebar.jsx